import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DEFAULT_TABLE_SIZE } from '@app/shared/tables/constants/default-table-size.constant';
import { TableType } from '@app/shared/tables/enums/table-type.enum';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';

export type TableSettings = Record<TableType, number>;

@Injectable({
  providedIn: 'root',
})
export class TableSettingsService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  private readonly _tablesSettings$: BehaviorSubject<TableSettings> = new BehaviorSubject<TableSettings>(
    DEFAULT_TABLE_SIZE
  );

  public getTableItemsPerPage(table: TableType): number {
    return this._tablesSettings$.getValue()[table] || DEFAULT_TABLE_SIZE[table];
  }

  public setTableItemsPerPage(table: TableType, size: number): Observable<TableSettings> {
    const data: TableSettings = {
      ...this._tablesSettings$.getValue(),
      [table]: size,
    };

    return this._httpClient.patch<TableSettings>('users/settings', data).pipe(
      tap(() => this._tablesSettings$.next(data)),
      map(() => data)
    );
  }

  public loadSettings(): Observable<TableSettings> {
    return this._httpClient.get<TableSettings>('users/settings').pipe(
      tap(data => {
        if (!data) {
          return;
        }
        this._tablesSettings$.next(data);
      })
    );
  }
}
